export const GET_CURRENT_USER_PAGE_RESPONSIBILITIES = "get_current_user_page_responsibilities";
export const getCurrentUserPageResponsibilities = () => {
  const url = `/page_responsibilities.json`;
  const request = axios.get(url);
  return {
    type: GET_CURRENT_USER_PAGE_RESPONSIBILITIES,
    payload: request,
  };
};
